module.exports = __webpack_public_path__ + "img/cc-icon-color.338843eb.png";